import React from 'react';
import {useGetMessages} from '../../../../hooks';
import {useFormContext} from 'react-hook-form';
import {Radio} from '@material-ui/core';
import {RadioGroup} from '../../../../components/v2';

export interface LegalAgeAcknowledgeProps {
    className?: string;
    isLoading?: boolean;
}

export interface LegalAgeAcknowledgeFieldValues {
    legalAgeAcknowledge: 'adult' | 'adultGuardian';
}

export const LegalAgeAcknowledge = React.memo<LegalAgeAcknowledgeProps>(
    ({className, isLoading}) => {
        const methods = useFormContext<LegalAgeAcknowledgeFieldValues>();
        const messages = useGetMessages({
            header: 'epic.affiliate.signup.legal.header',
            optionA: 'epic.affiliate.signup.legal.acknowledge18.v2',
            optionB: 'epic.affiliate.signup.legal.guardian.v2',
            required: 'errors.com.epicgames.validation.required_field.v2'
        });

        return (
            <RadioGroup
                required
                className={className}
                isLoading={isLoading}
                header={messages.header}
                control={methods.control}
                name="legalAgeAcknowledge"
                rules={{required: {value: true, message: messages.required}}}
                options={[
                    {label: messages.optionA, value: 'adult', control: <Radio />},
                    {label: messages.optionB, value: 'adultGuardian', control: <Radio />}
                ]}
            />
        );
    }
);

export default LegalAgeAcknowledge;
